import gsap from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import MotionPathPlugin from 'gsap/MotionPathPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'

// Register GSAP plugins safely
if (gsap) {
	gsap.registerPlugin(DrawSVGPlugin);
	gsap.registerPlugin(MotionPathPlugin);
	gsap.registerPlugin(ScrollTrigger);
}

const animatedIconBlockCollection = Array.from(document.querySelectorAll('.animated-icon-block'))

const animateColumn = (collection) => {
	const animationTime = collection.dataset.animationTime
	let animationDelay = collection.dataset.animationDelay
		

	const columnCollection = Array.from(collection.querySelectorAll('.animated-icon-column'))


	columnCollection.forEach((column, index) => {

		const localDelay = animationDelay * index
		const line = column.querySelector('.animation-line')
		const dot = column.querySelector('.animation-target')
		const text = column.querySelector('.text-container')

		gsap.to(line, {duration:animationTime, drawSVG: '100%', delay: localDelay});
		
		gsap.set(dot, {alpha: 1, delay: localDelay})
		gsap.to(dot, {duration:animationTime, motionPath: {
				path: line,
				align: line,
				alignOrigin: [0.5, 0.5],
				autoRotate: true
			},
			delay: localDelay
		})

		gsap.to(text, {duration: animationTime*1.1, y:0, ease: 'power3.out', delay: localDelay + animationTime*.4})
		gsap.to(text, {duration: animationTime*.7, alpha: 1, ease: 'power1.out', delay: localDelay + animationTime*.4})
	})


}

const configureStates = (collection) => {
	const columnCollection = Array.from(collection.querySelectorAll('.animated-icon-column'))

	columnCollection.forEach((column) => {

		const line = column.querySelector('.animation-line')
		const dot = column.querySelector('.animation-target')
		const text = column.querySelector('.text-container')

		gsap.set(dot, {alpha: 0})
		gsap.set(line, {drawSVG: 0})
		gsap.set(text, {y: 80, alpha: 0})
	})
}


if (animatedIconBlockCollection !== undefined) {

	animatedIconBlockCollection.forEach(collection => {
		configureStates(collection)
		ScrollTrigger.create({
			trigger: collection,
			start: 'top 60%',
			end: 'bottom bottom',
			once: true,
			onEnter: () => {
				animateColumn(collection)
			}
		})
	})

}